module.exports = __webpack_public_path__ + "img/weddings_01_V.16ae0a70.webp";